export const redirectToBilling = (url: string): void => {
  const destination = new URL(url);
  if (destination.protocol !== 'https:') throw new Error('Invalid billing destination');
  window.location.assign(destination.href);
};
